<script setup lang="ts">
import SimpleButton from "ls/components/simple-button/SimpleButton.vue";
import AuthLayout from "ls/layouts/Auth.vue";
import { toHome } from "ls/router/builders";
</script>

<template>
  <AuthLayout>
    <template #default>
      <h2 class="text-center font-semibold">
        This page doesn't exist
      </h2>
      <div class="mt-2 text-center text-slate-500">
        Please check the URL
      </div>
      <div class="mt-4 text-center">
        <SimpleButton
          :href="toHome()"
        >
          Go to Axure Cloud
        </SimpleButton>
      </div>
    </template>

    <template #secondary>
      <div class="mt-8 text-center text-slate-500">
        If you need some help, email us at <a class="underline" href="support@axure.com">support@axure.com</a>
      </div>
    </template>
  </AuthLayout>
</template>
